module.exports = __webpack_public_path__ + "img/women.f45d0d04.png";